import { Input, InputGroup, InputLeftElement, InputProps } from "@chakra-ui/react"
import { forwardRef } from "react"
import { FiType } from "react-icons/fi"

const TextInput = forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  return (
    <InputGroup>
      <InputLeftElement
        p={0}
        children={<FiType size={16} />}
      />
      <Input
        ref={ref}
        {...props}
      />
    </InputGroup>
  )
})

export default TextInput
